import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { NextServices } from '../index';

class Summary extends PureComponent {

  getClass(size) {
    const classNames = {};
    switch (size) {
      case 1:
        classNames['col-md-6'] = true;
        break;
      case 2:
        classNames['col-md-6'] = true;
        break;
      case 3:
        classNames['col-md-4'] = true;
        break;
      default:
        classNames['col-md-3'] = true;
    }
    return classNames;
  }

  render() {
    const { info } = this.props;
    const className = classnames(this.getClass(info.length));

    return (
      <div className="container summary">
        <h2>PRÓXIMOS EVENTOS <Link className="default-anchor" to={`/events`}>ver todos</Link></h2>
        <div className="row">
          {
            info.map((category) => {
              return (
                <div key={category.id} className={className}>
                  <NextServices {...category}/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

Summary.propTypes = {};
Summary.defaultProps = {};

export default Summary;



// WEBPACK FOOTER //
// ./src/components/summary/Summary.js